import React from 'react';
import styles from './Ingredients.module.scss';
import Image from 'next/image';
import { IngredientContent } from './ingredientContent';
import imgLoader from '../../../imgloader';
export default function Ingredients() {
  return (
    <div className={styles.ingredientContainer}>
      <h1 className={styles.ingredientHeading}>Ingredient Details</h1>

      {IngredientContent?.map((content) => (
        <div className={styles.medicineContainer}>
          <div className={styles.imageWrapper}>
            <Image
              alt={content?.alt || 'Image'}
              src={content?.image}
              height={230}
              width={230}
              objectFit="contain"
              loading="eager"
              loader={imgLoader}
            />
          </div>
          <div className={styles.medicineLeftside}>
            <div className={styles.imageWrapperMob}>
              <Image
                alt={content?.alt || 'Image'}
                src={content?.image}
                height={230}
                width={230}
                objectFit="contain"
                loading="eager"
                loader={imgLoader}
              />
            </div>
            <h2 className={styles.medicineHeading}>{content?.heading}</h2>
            {content?.content1 ? (
              <p
                className={styles.medicineContent}
                dangerouslySetInnerHTML={{ __html: content?.content1 }}
              ></p>
            ) : (
              ''
            )}
            {content?.content2 ? (
              <p
                className={styles.medicineContent}
                dangerouslySetInnerHTML={{ __html: content?.content2 }}
              ></p>
            ) : (
              ''
            )}
            {content?.content3 ? (
              <p
                className={styles.medicineContent}
                dangerouslySetInnerHTML={{ __html: content?.content3 }}
              ></p>
            ) : (
              ''
            )}
          </div>
        </div>
      ))}
      <div className={styles.refernceWrapper}>
        <h2 className={styles.referenceHeading}>References</h2>
        <ol className={styles.referenceOrderList}>
          <li>
            <a
              title="Goldberg RJ, Katz J."
              href="https://www.ncbi.nlm.nih.gov/pubmedhealth/PMH0024571/"
              target="_blank"
            >
              Goldberg RJ, Katz J.
            </a>{' '}
            A meta-analysis of the analgesic effects of omega-3 polyunsaturated
            fatty acid supplementation for inflammatory joint pain. Pain. 2007
            May;129(1-2):210-23.
          </li>
          <li>
            <a
              title="Maroon JC, Bost JW"
              href="https://www.ncbi.nlm.nih.gov/pubmed/16531187"
              target="_blank"
            >
              Maroon JC, Bost JW.
            </a>{' '}
            Omega-3 fatty acids (fish oil) as an anti-inflammatory: an
            alternative to nonsteroidal anti-inflammatory drugs for discogenic
            pain. Surg Neurol. 2006 Apr;65(4):326-31.
          </li>
          <li>
            Fontani G, Suman AL, Migliorini S, Corradeschi, Ceccarelli I, Aloisi
            A, Carli G. Administration of Omega-3 Fatty Acids Reduces Positive
            Tender Point Count in Chronic Musculoskeletal Pain Patients. Journal
            of Complementary and Integrative Medicine. 2010 Jan;7(1):Article 35.
          </li>
          <li>
            <a
              title="Maggio M, Artoni A, Lauretani F, Borghi L, Nouvenne A, Valenti G, Ceda GP."
              href="https://www.ncbi.nlm.nih.gov/pubmed/20041817"
              target="_blank"
            >
              Maggio M, Artoni A, Lauretani F, Borghi L, Nouvenne A, Valenti G,
              Ceda GP.
            </a>{' '}
            The impact of omega-3 fatty acids on osteoporosis. Curr Pharm Des.
            2009;15(36):4157-64
          </li>
          <li>
            <a
              title="Curtis CL, Hughes CE, Flannery CR, Little CB, Harwood JL, Caterson B."
              href="https://www.ncbi.nlm.nih.gov/pubmed/10625599"
              target="_blank"
            >
              Curtis CL, Hughes CE, Flannery CR, Little CB, Harwood JL, Caterson
              B.
            </a>{' '}
            n-3 fatty acids specifically modulate catabolic factors involved in
            articular cartilage degradation. J Biol Chem. 2000 Jan
            14;275(2):721-4.
          </li>
          <li>
            <a
              title="Zainal Z, Longman AJ, Hurst S, Duggan K, Caterson B, Hughes CE, Harwood JL. "
              href="https://www.ncbi.nlm.nih.gov/pubmed/19217322"
              target="_blank"
            >
              Zainal Z, Longman AJ, Hurst S, Duggan K, Caterson B, Hughes CE,
              Harwood JL.
            </a>{' '}
            Relative efficacies of omega-3 polyunsaturated fatty acids in
            reducing expression of key proteins in a model system for studying
            osteoarthritis. Osteoarthritis Cartilage. 2009 Jul;17(7):896-905.
          </li>
          <li>
            <a
              title="Wann AK, Mistry J, Blain EJ, Michael-Titus AT, Knight MM."
              href="https://www.ncbi.nlm.nih.gov/pubmed/21059244"
              target="_blank"
            >
              Wann AK, Mistry J, Blain EJ, Michael-Titus AT, Knight MM.
            </a>{' '}
            Eicosapentaenoic acid and docosahexaenoic acid reduce
            interleukin-1ß-mediated cartilage degradation. Arthritis Res Ther.
            2010;12(6):R207.
          </li>
          <li>
            <a
              title="Micallef MA, Munro IA, Garg ML."
              href="https://www.ncbi.nlm.nih.gov/pubmed/19352379"
              target="_blank"
            >
              Micallef MA, Munro IA, Garg ML.
            </a>{' '}
            An inverse relationship between plasma n-3 fatty acids and
            C-reactive protein in healthy individuals. Eur J Clin Nutr. 2009
            Sep;63(9):1154-6.
          </li>
          <li>
            <a
              title="Bloomer RJ, Larson DE, Fisher-Wellman KH, Galpin AJ, Schilling BK."
              href="https://www.ncbi.nlm.nih.gov/pubmed/19691834"
              target="_blank"
            >
              Bloomer RJ, Larson DE, Fisher-Wellman KH, Galpin AJ, Schilling BK.
            </a>{' '}
            Effect of eicosapentaenoic and docosahexaenoic acid on resting and
            exercise-induced inflammatory and oxidative stress biomarkers: a
            randomized, placebo controlled, cross-over study. Lipids Health Dis.
            2009 Aug 19;8:36.
          </li>
          <li>
            <a
              title="Skulas-Ray AC, Kris-Etherton PM, Harris WS, Vanden Heuvel JP, Wagner PR, West SG."
              href="https://www.ncbi.nlm.nih.gov/pubmed/21159789"
              target="_blank"
            >
              Skulas-Ray AC, Kris-Etherton PM, Harris WS, Vanden Heuvel JP,
              Wagner PR, West SG.
            </a>{' '}
            Dose-response effects of omega-3 fatty acids on triglycerides,
            inflammation, and endothelial function in healthy persons with
            moderate hypertriglyceridemia. Am J Clin Nutr. 2011
            Feb;93(2):243-52.
          </li>
          <li>
            <a
              title="Myhrstad MC, Retterstøl K, Telle-Hansen VH, Ottestad I, Halvorsen B, Holven KB, Ulven SM"
              href="https://www.ncbi.nlm.nih.gov/pubmed/21229287"
              target="_blank"
            >
              Myhrstad MC, Retterstøl K, Telle-Hansen VH, Ottestad I, Halvorsen
              B, Holven KB, Ulven SM
            </a>
            . Effect of marine n-3 fatty acids on circulating inflammatory
            markers in healthy subjects and subjects with cardiovascular risk
            factors. Inflamm Res. 2011 Apr;60(4):309-19.
          </li>
          <li>
            <a
              title="Ebrahimi M, Ghayour-Mobarhan M, Rezaiean S, Hoseini M, Parizade SM, Farhoudi F, Hosseininezhad SJ, Tavallaei S, Vejdani A, Azimi-Nezhad M, Shakeri MT, Rad MA, Mobarra N, Kazemi-Bajestani SM, Ferns GA."
              href="https://www.ncbi.nlm.nih.gov/pubmed/19593941"
              target="_blank"
            >
              Ebrahimi M, Ghayour-Mobarhan M, Rezaiean S, Hoseini M, Parizade
              SM, Farhoudi F, Hosseininezhad SJ, Tavallaei S, Vejdani A,
              Azimi-Nezhad M, Shakeri MT, Rad MA, Mobarra N, Kazemi-Bajestani
              SM, Ferns GA.
            </a>{' '}
            Omega-3 fatty acid supplements improve the cardiovascular risk
            profile of subjects with metabolic syndrome, including markers of
            inflammation and auto-immunity. Acta Cardiol. 2009 Jun;64(3):321-7.
          </li>
          <li>
            <a
              title="Ko GD, Nowacki NB, Arseneau L, Eitel M, Hum A."
              href="https://www.ncbi.nlm.nih.gov/pubmed/20090445"
              target="_blank"
            >
              Ko GD, Nowacki NB, Arseneau L, Eitel M, Hum A.
            </a>{' '}
            Omega-3 fatty acids for neuropathic pain: case series. Clin J Pain.
            2010 Feb;26(2):168-72. PubMed PMID: 20090445.
          </li>
          <li>
            <a
              title="Monahan KD, Wilson TE, Ray CA."
              href="https://www.ncbi.nlm.nih.gov/pubmed/15452023"
              target="_blank"
            >
              Monahan KD, Wilson TE, Ray CA.
            </a>{' '}
            Omega-3 fatty acid supplementation augments sympathetic nerve
            activity responses to physiological stressors in humans.
            Hypertension. 2004 Nov;44(5):732-8.
          </li>
          <li>
            <a
              title="Lin PY, Su KP."
              href="https://www.ncbi.nlm.nih.gov/pubmed/17685742"
              target="_blank"
            >
              Lin PY, Su KP.
            </a>{' '}
            A meta-analytic review of double-blind, placebo-controlled trials of
            antidepressant efficacy of omega-3 fatty acids. J Clin Psychiatry.
            2007 Jul;68(7):1056-61.
          </li>
          <li>
            <a
              title="James M, Proudman S, Cleland L."
              href="https://www.ncbi.nlm.nih.gov/pubmed/20509981"
              target="_blank"
            >
              James M, Proudman S, Cleland L.
            </a>{' '}
            Fish oil and rheumatoid arthritis: past, present and future. Proc
            Nutr Soc. 2010 Aug;69(3):316-23.
          </li>
          <li>
            <a
              title="Aggarwal BB, Harikumar KB."
              href="https://www.ncbi.nlm.nih.gov/pubmed/18662800"
              target="_blank"
            >
              Aggarwal BB, Harikumar KB.
            </a>{' '}
            Potential therapeutic effects of curcumin, the anti-inflammatory
            agent, against neurodegenerative, cardiovascular, pulmonary,
            metabolic, autoimmune and neoplastic diseases. Int J Biochem Cell
            Biol. 2009 Jan;41(1):40-59.
          </li>
          <li>
            <a
              title="Deodhar SD, Sethi R, Srimal RC."
              href="https://www.ncbi.nlm.nih.gov/pubmed/7390600"
              target="_blank"
            >
              Deodhar SD, Sethi R, Srimal RC.
            </a>{' '}
            Preliminary study on antirheumatic activity of curcumin. Indian J
            Med Res 1980;71:632-34.
          </li>
          <li>
            <a
              title="Zhou H, Beevers CS, Huang S."
              href="https://www.ncbi.nlm.nih.gov/pubmed/20955148"
              target="_blank"
            >
              Zhou H, Beevers CS, Huang S.
            </a>{' '}
            The targets of curcumin. Curr Drug Targets. 2011 Mar 1;12(3):332-47.
            Review.
          </li>
          <li>
            <a
              title="Singh S, Aggarwal BB."
              href="https://www.ncbi.nlm.nih.gov/pubmed/7559628"
              target="_blank"
            >
              Singh S, Aggarwal BB.
            </a>{' '}
            Activation of transcription factor NF-kappa B is suppressed by
            curcumin (diferuloylmethane) [corrected]. J Biol Chem. 1995 Oct
            20;270(42):24995-5000.
          </li>
          <li>
            <a
              title="Dhillon N, Aggarwal BB, Newman RA, Wolff RA, Kunnumakkara AB, Abbruzzese JL, Ng CS, Badmaev V, Kurzrock R."
              href="https://www.ncbi.nlm.nih.gov/pubmed/18628464"
              target="_blank"
            >
              Dhillon N, Aggarwal BB, Newman RA, Wolff RA, Kunnumakkara AB,
              Abbruzzese JL, Ng CS, Badmaev V, Kurzrock R.
            </a>{' '}
            Phase II trial of curcumin in patients with advanced pancreatic
            cancer. Clin Cancer Res. 2008 Jul 15;14(14):4491-9.
          </li>
          <li>
            <a
              title="Shakibaei M, Mobasheri A, Buhrmann C."
              href="https://www.ncbi.nlm.nih.gov/pubmed/21484156"
              target="_blank"
            >
              Shakibaei M, Mobasheri A, Buhrmann C.
            </a>{' '}
            Curcumin synergizes with resveratrol to stimulate the MAPK signaling
            pathway in human articular chondrocytes in vitro. Genes Nutr. 2011
            May;6(2):171-9.
          </li>
          <li>
            <a
              title="Kang G, Kong PJ, Yuh YJ, Lim SY, Yim SV, Chun W, Kim SS."
              href="https://www.ncbi.nlm.nih.gov/pubmed/15037818"
              target="_blank"
            >
              Kang G, Kong PJ, Yuh YJ, Lim SY, Yim SV, Chun W, Kim SS.
            </a>{' '}
            Curcumin suppresses lipopolysaccharide-induced cyclooxygenase-2
            expression by inhibiting activator protein 1 and nuclear factor
            kappaB bindings in BV2 microglial cells. J Pharm Sci 94: 325–328,
            2004.
          </li>
          <li>
            <a
              title="Davis JM, Murphy EA, Carmichael MD, Zielinski MR, Groschwitz CM, Brown AS, Gangemi JD, Ghaffar A, Mayer EP. "
              href="https://www.ncbi.nlm.nih.gov/pubmed/17332159"
              target="_blank"
            >
              Davis JM, Murphy EA, Carmichael MD, Zielinski MR, Groschwitz CM,
              Brown AS, Gangemi JD, Ghaffar A, Mayer EP.
            </a>{' '}
            Curcumin effects on inflammation and performance recovery following
            eccentric exercise-induced muscle damage. Am J Physiol Regul Integr
            Comp Physiol. 2007 Jun;292(6):R2168-73.
          </li>
          <li>
            <a
              title="Thaloor D, Miller KJ, Gephart J, Mitchell PO, Pavlath GK."
              href="https://www.ncbi.nlm.nih.gov/pubmed/10444409"
              target="_blank"
            >
              Thaloor D, Miller KJ, Gephart J, Mitchell PO, Pavlath GK.
            </a>{' '}
            Systemic administration of the NF-kappaB inhibitor curcumin
            stimulates muscle regeneration after traumatic injury. Am J Physiol.
            1999 Aug;277(2 Pt 1):C320-9.
          </li>
          <li>
            <a
              title="Yeon KY, Kim SA, Kim YH, Lee MK, Ahn DK, Kim HJ, Kim JS, Jung SJ, Oh SB."
              href="https://www.ncbi.nlm.nih.gov/pubmed/20040737"
              target="_blank"
            >
              Yeon KY, Kim SA, Kim YH, Lee MK, Ahn DK, Kim HJ, Kim JS, Jung SJ,
              Oh SB.
            </a>{' '}
            Curcumin produces an antihyperalgesic effect via antagonism of
            TRPV1. J Dent Res. 2010 Feb;89(2):170-4.
          </li>
          <li>
            <a
              title="Mittal N, Joshi R, Hota D, Chakrabarti A."
              href="https://www.ncbi.nlm.nih.gov/pubmed/19051211"
              target="_blank"
            >
              Mittal N, Joshi R, Hota D, Chakrabarti A.
            </a>{' '}
            Evaluation of antihyperalgesic effect of curcumin on
            formalin-induced orofacial pain in rat. Phytother Res. 2009
            Apr;23(4):507-12.
          </li>
          <li>
            <a
              title="Sharma S, Kulkarni SK, Agrewala JN, Chopra K."
              href="https://www.ncbi.nlm.nih.gov/pubmed/16584726"
              target="_blank"
            >
              Sharma S, Kulkarni SK, Agrewala JN, Chopra K.
            </a>{' '}
            Curcumin attenuates thermal hyperalgesia in a diabetic mouse model
            of neuropathic pain. Eur J Pharmacol. 2006 May 1;536(3):256-61.
          </li>
          <li>
            <a
              title="Tajik H, Tamaddonfard E, Hamzeh-Gooshchi N."
              href="https://www.ncbi.nlm.nih.gov/pubmed/18817212"
              target="_blank"
            >
              Tajik H, Tamaddonfard E, Hamzeh-Gooshchi N.
            </a>{' '}
            The effect of curcumin (active substance of turmeric) on the acetic
            acid-induced visceral nociception in rats. Pak J Biol Sci. 2008 Jan
            15;11(2):312-4.
          </li>
          <li>
            <a
              title="Sharma S, Chopra K, Kulkarni SK."
              href="https://www.ncbi.nlm.nih.gov/pubmed/17199240"
              target="_blank"
            >
              Sharma S, Chopra K, Kulkarni SK.
            </a>{' '}
            Effect of insulin and its combination with resveratrol or curcumin
            in attenuation of diabetic neuropathic pain participation of nitric
            oxide and TNF-alpha. Phytother Res. 2007 Mar;21(3):278-83.
          </li>
          <li>
            <a
              title="Pham-Marcou TA, Beloeil H, Sun X, Gentili M, Yaici D, Benoit G, Benhamou D, Mazoit JX."
              href="https://www.ncbi.nlm.nih.gov/pubmed/18814970"
              target="_blank"
            >
              Pham-Marcou TA, Beloeil H, Sun X, Gentili M, Yaici D, Benoit G,
              Benhamou D, Mazoit JX.
            </a>{' '}
            Antinociceptive effect of resveratrol in carrageenan-evoked
            hyperalgesia in rats: prolonged effect related to COX-2 expression
            impairment. Pain. 2008 Nov 30;140(2):274-83. Epub 2008 Sep 23.
          </li>
          <li>
            <a
              title="Sharma S, Kulkarni SK, Chopra K."
              href="https://www.ncbi.nlm.nih.gov/pubmed/17227449"
              target="_blank"
            >
              Sharma S, Kulkarni SK, Chopra K.
            </a>{' '}
            Effect of resveratrol, a polyphenolic phytoalexin, on thermal
            hyperalgesia in a mouse model of diabetic neuropathic pain. Fundam
            Clin Pharmacol. 2007 Feb;21(1):89-94.
          </li>
          <li>
            <a
              title="Sharma S, Chopra K, Kulkarni SK."
              href="https://www.ncbi.nlm.nih.gov/pubmed/17199240"
              target="_blank"
            >
              Sharma S, Chopra K, Kulkarni SK.
            </a>{' '}
            Effect of insulin and its combination with resveratrol or curcumin
            in attenuation of diabetic neuropathic pain: participation of nitric
            oxide and TNF-alpha. Phytother Res. 2007 Mar;21(3):278-83.
          </li>
          <li>
            <a
              title="Granados-Soto V, Argüelles CF, Ortiz MI."
              href="https://www.ncbi.nlm.nih.gov/pubmed/18605235"
              target="_blank"
            >
              Granados-Soto V, Argüelles CF, Ortiz MI.
            </a>{' '}
            The peripheral antinociceptive effect of resveratrol is associated
            with activation of potassium channels. Neuropharmacology. 2002
            Oct;43(5):917-23.
          </li>
          <li>
            <a
              title="Torres-López JE, Ortiz MI, Castañeda-Hernández G, Alonso-López R, Asomoza-Espinosa R, Granados-Soto V."
              href="https://www.ncbi.nlm.nih.gov/pubmed/11991254"
              target="_blank"
            >
              Torres-López JE, Ortiz MI, Castañeda-Hernández G, Alonso-López R,
              Asomoza-Espinosa R, Granados-Soto V.
            </a>{' '}
            Comparison of the antinociceptive effect of celecoxib, diclofenac
            and resveratrol in the formalin test. Life Sci. 2002 Feb
            22;70(14):1669-76.
          </li>
          <li>
            <a
              title="Falchi M, Bertelli A, Galazzo R, Viganò P, Dib B."
              href="https://www.ncbi.nlm.nih.gov/pubmed/21308652"
              target="_blank"
            >
              Falchi M, Bertelli A, Galazzo R, Viganò P, Dib B.
            </a>{' '}
            Central antalgic activity of resveratrol. Arch Ital Biol. 2010
            Dec;148(4):389-96.
          </li>
          <li>
            <a
              title="Utreras E, Terse A, Keller J, Iadarola MJ, Kulkarni AB."
              href="https://www.ncbi.nlm.nih.gov/pubmed/21736731"
              target="_blank"
            >
              Utreras E, Terse A, Keller J, Iadarola MJ, Kulkarni AB.
            </a>{' '}
            Resveratrol inhibits Cdk5 activity through regulation of p35
            expression. Mol Pain. 2011 Jul 7;7:49.
          </li>
          <li>
            <a
              title="Wuertz K, Quero L, Sekiguchi M, Klawitter M, Nerlich A, Konno S, Kikuchi S, Boos N."
              href="https://www.ncbi.nlm.nih.gov/pubmed/21587103"
              target="_blank"
            >
              Wuertz K, Quero L, Sekiguchi M, Klawitter M, Nerlich A, Konno S,
              Kikuchi S, Boos N.
            </a>{' '}
            The red wine polyphenol resveratrol shows promising potential for
            the treatment of nucleus pulposus mediated pain in vitro and in
            vivo. Spine (Phila Pa 1976). 2011 May 14.
          </li>
          <li>
            <a
              title="Shakibaei M, Csaki C, Nebrich S, Mobasheri A."
              href="https://www.ncbi.nlm.nih.gov/pubmed/18606398"
              target="_blank"
            >
              Shakibaei M, Csaki C, Nebrich S, Mobasheri A.
            </a>{' '}
            Resveratrol suppresses interleukin-1beta-induced inflammatory
            signaling and apoptosis in human articular chondrocytes: potential
            for use as a novel nutraceutical for the treatment of
            osteoarthritis. Biochem Pharmacol. 2008 Dec 1;76(11):1426-39.
          </li>
          <li>
            <a
              title="Baur JA, Sinclair DA."
              href="https://www.ncbi.nlm.nih.gov/pubmed/16732220"
              target="_blank"
            >
              Baur JA, Sinclair DA.
            </a>{' '}
            Therapeutic potential of resveratrol: the in vivo evidence. Nat Rev
            Drug Discov. 2006 Jun;5(6):493-506. Epub 2006 May 26.
          </li>
          <li>
            <a
              title="Sharma RA, Steward WP, Gescher AJ."
              href="https://www.ncbi.nlm.nih.gov/pubmed/17569224"
              target="_blank"
            >
              Sharma RA, Steward WP, Gescher AJ.
            </a>{' '}
            Pharmacokinetics and pharmacodynamics of curcumin. Adv Exp Med Biol.
            2007;595:453-70.
          </li>
          <li>
            <a
              title="Hsu CH, Cheng AL."
              href="https://www.ncbi.nlm.nih.gov/pubmed/17569225"
              target="_blank"
            >
              Hsu CH, Cheng AL.
            </a>{' '}
            Clinical studies with curcumin. Adv Exp Med Biol. 2007;595:471-80.
          </li>
          <li>
            <a
              title="Gonzales AM, Orlando RA."
              href="https://www.ncbi.nlm.nih.gov/pubmed/18549505"
              target="_blank"
            >
              Gonzales AM, Orlando RA.
            </a>{' '}
            Curcumin and resveratrol inhibit nuclear factor-kappaB-mediated
            cytokine expression in adipocytes. Nutr Metab (Lond). 2008 Jun
            12;5:17.
          </li>
          <li>
            <a
              title="Vang O, Ahmad N, Baile CA, Baur JA, Brown K, Csiszar A, Das DK, Delmas D, Gottfried C, Lin HY, Ma QY, Mukhopadhyay P, Nalini N, Pezzuto JM, Richard T, Shukla Y, Surh YJ, Szekeres T, Szkudelski T, Walle T, Wu JM."
              href="https://www.ncbi.nlm.nih.gov/pubmed/21698226"
              target="_blank"
            >
              Vang O, Ahmad N, Baile CA, Baur JA, Brown K, Csiszar A, Das DK,
              Delmas D, Gottfried C, Lin HY, Ma QY, Mukhopadhyay P, Nalini N,
              Pezzuto JM, Richard T, Shukla Y, Surh YJ, Szekeres T, Szkudelski
              T, Walle T, Wu JM.
            </a>{' '}
            What is new for an old molecule? Systematic review and
            recommendations on the use of resveratrol. PLoS One.
            2011;6(6):e19881.
          </li>
          <li>
            <a
              title="Patel KR, Scott E, Brown VA, Gescher AJ, Steward WP, Brown K."
              href="https://www.ncbi.nlm.nih.gov/pubmed/21261655"
              target="_blank"
            >
              Patel KR, Scott E, Brown VA, Gescher AJ, Steward WP, Brown K.
            </a>{' '}
            Clinical trials of resveratrol. Ann N Y Acad Sci. 2011
            Jan;1215:161-9.
          </li>
          <li>
            <a
              title="Ghanim H, Sia CL, Abuaysheh S, Korzeniewski K, Patnaik P, Marumganti A, Chaudhuri A, Dandona P."
              href="https://www.ncbi.nlm.nih.gov/pubmed/20534755"
              target="_blank"
            >
              Ghanim H, Sia CL, Abuaysheh S, Korzeniewski K, Patnaik P,
              Marumganti A, Chaudhuri A, Dandona P.
            </a>{' '}
            An antiinflammatory and reactive oxygen species suppressive effects
            of an extract of Polygonum cuspidatum containing resveratrol. J Clin
            Endocrinol Metab. 2010 Sep;95(9):E1-8.
          </li>
          <li>
            <a
              title="Liu MH, Sun JS, Tsai SW, Sheu SY, Chen MH."
              href="https://www.ncbi.nlm.nih.gov/pubmed/20116661"
              target="_blank"
            >
              Liu MH, Sun JS, Tsai SW, Sheu SY, Chen MH.
            </a>{' '}
            Icariin protects murine chondrocytes from lipopolysaccharide-induced
            inflammatory responses and extracellular matrix degradation. Nutr
            Res. 2010 Jan;30(1):57-65.
          </li>
          <li>
            <a
              title="Zhao F, Tang YZ, Liu ZQ."
              href="https://www.ncbi.nlm.nih.gov/pubmed/18053336"
              target="_blank"
            >
              Zhao F, Tang YZ, Liu ZQ.
            </a>{' '}
            Protective effect of icariin on DNA against radical-induced
            oxidative damage. J Pharm Pharmacol. 2007 Dec;59(12):1729-32.
          </li>
          <li>
            <a
              title="Wo YB, Zhu DY, Hu Y, Wang ZQ, Liu J, Lou YJ."
              href="https://www.ncbi.nlm.nih.gov/pubmed/17985362"
              target="_blank"
            >
              Wo YB, Zhu DY, Hu Y, Wang ZQ, Liu J, Lou YJ.
            </a>{' '}
            Reactive oxygen species involved in prenylflavonoids, icariin and
            icaritin, initiating cardiac differentiation of mouse embryonic stem
            cells. J Cell Biochem. 2008 Apr 1;103(5):1536-50.
          </li>
          <li>
            <a
              title="Xu CQ, Liu BJ, Wu JF, Xu YC, Duan XH, Cao YX, Dong JC."
              href="https://www.ncbi.nlm.nih.gov/pubmed/20519138"
              target="_blank"
            >
              Xu CQ, Liu BJ, Wu JF, Xu YC, Duan XH, Cao YX, Dong JC.
            </a>{' '}
            Icariin attenuates LPS-induced acute inflammatory responses:
            involvement of PI3K/Akt and NF-kappaB signaling pathway. Eur J
            Pharmacol. 2010 Sep 10;642(1-3):146-53.
          </li>
          <li>
            <a
              title="Zhang L, Huang S, Chen Y, Wang Z, Li E, Xu Y. Icariin"
              href="https://www.ncbi.nlm.nih.gov/pubmed/20533910"
              target="_blank"
            >
              Zhang L, Huang S, Chen Y, Wang Z, Li E, Xu Y. Icariin
            </a>{' '}
            Inhibits Hydrogen Peroxide-Mediated Cytotoxicity by Up-regulating
            Sirtuin Type 1-Dependent Catalase and Peroxiredoxin. Basic Clin
            Pharmacol Toxicol. 2010 Aug 19.
          </li>
          <li>
            <a
              title="Wu JF, Dong JC, Xu CQ."
              href="https://www.ncbi.nlm.nih.gov/pubmed/19526759"
              target="_blank"
            >
              Wu JF, Dong JC, Xu CQ.
            </a>{' '}
            [Effects of icariin on inflammation model stimulated by
            lipopolysaccharide in vitro and in vivo]. Zhongguo Zhong Xi Yi Jie
            He Za Zhi. 2009 Apr;29(4):330-4.
          </li>
        </ol>
      </div>
    </div>
  );
}
